/**
 * Agent Alert Context Menu Service
 *
 * Handles context menu actions for agent-alert nodes in the Object Explorer.
 */

import type { AgentAlertNodeMetadata } from '../../explorer/models/nodeTypes';
import { openAgentWorkspace, deleteAgentObject, toggleAlertEnabled } from './agentContextMenuHelper';

export function executeAgentAlertContextMenuAction(
  actionId: string,
  metadata: AgentAlertNodeMetadata,
  callbacks: { onRefresh: () => void },
) {
  const { connectionId, alertName, enabled } = metadata;

  if (actionId === 'edit-alert') {
    openAgentWorkspace(connectionId, 'alerts', { type: 'alert', name: alertName });
  } else if (actionId === 'toggle-alert') {
    void toggleAlertEnabled(connectionId, alertName, enabled, callbacks.onRefresh);
  } else if (actionId === 'delete-alert') {
    void deleteAgentObject(
      connectionId, 'Alert', alertName,
      (args) => window.electronAPI?.jobScheduler?.deleteAlert(args) ?? Promise.resolve({ success: false, error: 'API not available' }),
      callbacks.onRefresh,
    );
  }
}
